import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { LabelState } from '../../types'

export const fetchLabelsByCompanyAndOperatorAction = createAsyncAction(
  '@chat/FETCH_LABELS_BY_COMPANY_AND_OPERATOR_REQUEST',
  '@chat/FETCH_LABELS_BY_COMPANY_AND_OPERATOR_SUCCESS',
  '@chat/FETCH_LABELS_BY_COMPANY_AND_OPERATOR_FAILURE'
)<Request, Success, Failure>()

const request = (state: LabelState): LabelState => ({
  ...state,
  isLoadingFetchLabelsByCompanyAndOperator: true
})

const success = (
  state: LabelState,
  action: ActionType<typeof fetchLabelsByCompanyAndOperatorAction.success>
): LabelState => {
  return {
    ...state,
    labels: action.payload.labels,
    isLoadingFetchLabelsByCompanyAndOperator: false,
    isSuccessOnFetchLabelsByCompanyAndOperator: true
  }
}
const failure = (
  state: LabelState,
  action: ActionType<typeof fetchLabelsByCompanyAndOperatorAction.failure>
): LabelState => ({
  ...state,
  isLoadingFetchLabelsByCompanyAndOperator: false,
  isErrorOnFetchLabelsByCompanyAndOperator: true
})

export const fetchLabelsByCompanyAndOperatorHandle = {
  asyncAction: fetchLabelsByCompanyAndOperatorAction,
  request,
  success,
  failure
}
